import { useEffect, useRef, useState } from 'react';
import { HttpError, errText, post } from '../api/client';

/**
 * The link in the "confirm your new email" mail (/confirm-email?token=...): it must be opened signed in as the account that asked.
 * Tries the team door first, then the portal's (a client account reaches only the second), and says the result in words.
 */
export function ConfirmEmail() {
  const [state, setState] = useState<{ kind: 'busy' } | { kind: 'done'; email: string } | { kind: 'error'; text: string; signIn?: boolean }>({ kind: 'busy' });
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const token = new URLSearchParams(location.search).get('token') ?? '';
    const go = async () => {
      try { return await post<{ email: string }>('/profile/email/confirm', { token }); } catch (e) {
        if (e instanceof HttpError && (e.code as string) === 'portal_only') return await post<{ email: string }>('/portal/profile/email/confirm', { token });
        throw e;
      }
    };
    go().then((r) => setState({ kind: 'done', email: r.email }), (e) => setState({ kind: 'error', text: errText(e), signIn: e instanceof HttpError && e.status === 401 }));
  }, []);
  return (
    <div className="mx-auto flex min-h-full max-w-[460px] flex-col justify-center gap-4 px-4 py-10" data-testid="confirm-email">
      <h1 className="text-[24px] font-semibold tracking-tight">Confirm your new email</h1>
      {state.kind === 'busy' ? <p className="flex items-center gap-3 text-[15px] text-dim" role="status"><span className="h-5 w-5 animate-spin rounded-full border-2 border-line border-t-accent" />One moment…</p> : null}
      {state.kind === 'done' ? (
        <>
          <p className="text-[15px] text-dim" role="status" data-testid="confirm-email-done">Done. You now sign in with <b className="text-ink">{state.email}</b>. Your other devices were signed out.</p>
          <button className="btn-primary btn-lg" onClick={() => location.assign('/')}>Carry on</button>
        </>
      ) : null}
      {state.kind === 'error' ? (
        <>
          <p className="text-[15px] text-bad-text" role="alert" data-testid="confirm-email-error">{state.signIn ? 'Sign in as the account that asked for the change, then open the link again.' : state.text}</p>
          <button className="btn-primary btn-lg" onClick={() => location.assign('/')}>{state.signIn ? 'Sign in' : 'Back'}</button>
        </>
      ) : null}
    </div>
  );
}
